import * as SmartFormObj from "./SmartForm"
import * as OptOutObj from "./OptOut"
import * as PreferenceCenterObj from "./PreferenceCenter"

const objects = {
    SmartForm: SmartFormObj,
    PreferenceCenter: PreferenceCenterObj,
    OptOut: OptOutObj
}

const classes = {
    SmartForm: SmartFormObj.SmartForm,
    PreferenceCenter: PreferenceCenterObj.PreferenceCenter,
    OptOut: OptOutObj.OptOut
}

export function getTypeClass(name) {
    return classes[name];
}

export function getTypeFields(name) {
    return objects[name].additionalFields;
}

export function getTypeFieldsSchema(name) {
    return objects[name].additionalFieldsSchema;
}